<template>
  <div>
    <p>Traduction demandée.</p>
    <p>Devis accepté.</p>
    <hr/>
    <div class="field">
      <label class="label">Traduction</label>
      <div class="control">
        <CharCounterTextarea
            textarea-class="textarea"
            v-model="context.data.text_native"
            :max="max_chars"
            :readonly="!context.active"
        />
      </div>
    </div>
    <a
        class="button is-pulled-right is-small"
        :class="isOverLimit ? 'is-danger' : 'is-primary'"
        @click="save_answer()"
        :disabled="!context.active || context.data.text_native === '' || isOverLimit"
    >
      Enregistrer
    </a>
    <br/>
  </div>
</template>


<script>
import tools from "@/tools.js";
import CharCounterTextarea from "@/components/ui/CharCounterTextarea.vue";

export default {
  name: "StateTranslationNeeded",
  components: {CharCounterTextarea},
  props: {
    context: {
      type: Object,
      required: true,
    },
    review: Object,
  },
  computed: {
    max_chars() {
      return tools.nbr_char_max(this.review ? this.review.platform : null);
    },
    isOverLimit() {
      return tools.is_over_limit(this.context.data.text_native, this.max_chars);
    },
  },
  methods: {
    save_answer() {
      // L'attribut disabled n'a aucun effet sur un <a> : on bloque ici.
      if (this.isOverLimit) {
        return;
      }
      this.$emit("state:update_data", this.context.data);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
